var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Tipo_ReembolsoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Tipo_ReembolsoModule = class Tipo_ReembolsoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Tipo_ReembolsoActions.POST_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Tipo_Reembolso/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Tipo_ReembolsoActions.PUT_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.put("Tipo_Reembolso/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Tipo_ReembolsoActions.DELETE_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Tipo_Reembolso/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Tipo_ReembolsoActions.DELETE_RANGE_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Tipo_Reembolso/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Tipo_ReembolsoActions.FILTER_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Tipo_Reembolso/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Tipo_ReembolsoActions.GET_TIPO_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Tipo_Reembolso/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Tipo_ReembolsoActions.GETWITHDISABLED_TIPO_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Tipo_Reembolso/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Tipo_ReembolsoActions.GET_BY_ID_TIPO_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.get("Tipo_Reembolso/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_ReembolsoModule.prototype, _h, null);
Tipo_ReembolsoModule = __decorate([
    Module
], Tipo_ReembolsoModule);
export default Tipo_ReembolsoModule;
//# sourceMappingURL=Tipo_ReembolsoModule.js.map